import stylesSpinner from './Spinner.module.scss';
interface ISpinnerProps {
  className?: string;
}

export default function Spinner({ className = '' }: ISpinnerProps) {
  return (
    <div className={className}>
      <span className={`${stylesSpinner.skWave}`}>
        <span className={`${stylesSpinner.skWaveRect}`}></span>
        <span className={`${stylesSpinner.skWaveRect}`}></span>
        <span className={`${stylesSpinner.skWaveRect}`}></span>
        <span className={`${stylesSpinner.skWaveRect}`}></span>
        <span className={`${stylesSpinner.skWaveRect}`}></span>
      </span>
    </div>
  );
}
